import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "wrapper pt-5" }
const _hoisted_2 = { class: "d-flex flex-row justify-content-between align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Übersicht Ihrer noch nicht übertragenen Einstellungen ")
const _hoisted_4 = ["disabled"]
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, " Prüfen Sie die Unterschiede Ihrer Interventionskontake ")
], -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "media-list media-list-linked media-list-bordered" }
const _hoisted_9 = { class: "media bg-light font-weight-semibold py-2" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "d-flex flex-column" }
const _hoisted_12 = { class: "d-flex flex-row align-items-center" }
const _hoisted_13 = { class: "rotate-180 ml-2" }
const _hoisted_14 = { class: "d-flex flex-row align-items-center" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "icon-circle-down2" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["id"]
const _hoisted_18 = { class: "px-3 pb-3" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = { class: "col-12 col-md-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center mb-0" }, " Aktuell eingestellt ", -1)
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "col-12 col-md-6" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center mb-0" }, " Noch nicht übertragen ", -1)
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "card" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, " Prüfen Sie die Unterschiede Ihrer Interventionen ")
], -1)
const _hoisted_28 = { class: "card-body" }
const _hoisted_29 = { class: "media-list media-list-linked media-list-bordered" }
const _hoisted_30 = { class: "media bg-light font-weight-semibold py-2" }
const _hoisted_31 = ["href"]
const _hoisted_32 = { class: "d-flex flex-column" }
const _hoisted_33 = { class: "d-flex flex-row align-items-center" }
const _hoisted_34 = { class: "rotate-180 ml-2" }
const _hoisted_35 = { class: "d-flex flex-row align-items-center" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("i", { class: "icon-circle-down2" }, null, -1)
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = ["id"]
const _hoisted_39 = { class: "px-3 pb-3" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-12 col-md-6" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center mb-0" }, " Aktuell eingestellt ", -1)
const _hoisted_43 = { class: "table" }
const _hoisted_44 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_45 = { class: "d-flex flex-row flex-wrap mt-3" }
const _hoisted_46 = { class: "col-12 col-md-6" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("legend", { class: "text-uppercase font-size-sm font-weight-bold d-flex flex-row align-items-center mb-0" }, " Noch nicht übertragen ", -1)
const _hoisted_48 = { class: "table" }
const _hoisted_49 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_50 = { class: "d-flex flex-row flex-wrap mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("button", {
        class: "btn btn-primary",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sendInterventionsToLisa && _ctx.sendInterventionsToLisa(...args))),
        disabled: _ctx.interventionConf.length <= 0 && _ctx.contactConf <= 0
      }, " Änderungen übertragen ", 8, _hoisted_4)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _hoisted_6,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("ul", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactConf, (object, oIndex) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: oIndex }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(object.systems, (system, sIndex) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: sIndex }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(system.interventionTypes, (type, tIndex) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: tIndex }, [
                      _createElementVNode("li", _hoisted_9, [
                        _createElementVNode("a", {
                          class: "text-body collapsed d-flex flex-row align-items-center justify-content-between w-100",
                          href: '#collapse-icon-contacts-'+oIndex+sIndex+tIndex,
                          "data-toggle": "collapse"
                        }, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("span", null, _toDisplayString(object.company), 1),
                            _createElementVNode("small", null, _toDisplayString(object.street) + " " + _toDisplayString(object.houseNumber) + " | " + _toDisplayString(object.zipCode) + " " + _toDisplayString(object.city), 1),
                            _createElementVNode("span", _hoisted_12, [
                              _createTextVNode(_toDisplayString(system.name) + " | " + _toDisplayString(_ctx.interventionTypesConf[tIndex]['name']) + " ", 1),
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(_ctx.interventionTypesConf[tIndex]['icon'])
                                }, null, 2)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("a", {
                              href: "",
                              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
                              class: "text-body",
                              "data-toggle": "collapse",
                              "aria-expanded": "false"
                            }, _hoisted_16)
                          ])
                        ], 8, _hoisted_10)
                      ]),
                      _createElementVNode("div", {
                        class: "collapse",
                        id: 'collapse-icon-contacts-'+oIndex+sIndex+tIndex
                      }, [
                        _createElementVNode("li", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _hoisted_21,
                              _createElementVNode("table", null, [
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.old, (contact, oldIndex) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: oldIndex }, [
                                      contact
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                                            _createElementVNode("td", null, _toDisplayString(contact.firstName) + " " + _toDisplayString(contact.lastName) + " | " + _toDisplayString(contact.phone), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128))
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _hoisted_24,
                              _createElementVNode("table", null, [
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.new, (contact, newIndex) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, { key: newIndex }, [
                                      contact
                                        ? (_openBlock(), _createElementBlock("tr", _hoisted_25, [
                                            _createElementVNode("td", null, _toDisplayString(contact.firstName) + " " + _toDisplayString(contact.lastName) + " | " + _toDisplayString(contact.phone), 1)
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 128))
                                ])
                              ])
                            ])
                          ])
                        ])
                      ], 8, _hoisted_17)
                    ], 64))
                  }), 128))
                ], 64))
              }), 128))
            ], 64))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_26, [
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("ul", _hoisted_29, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.interventionConf, (object, oIndex) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: oIndex }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(object.systems, (system, sIndex) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: sIndex }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(system.interventionTypes, (type, tIndex) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: tIndex }, [
                      _createElementVNode("li", _hoisted_30, [
                        _createElementVNode("a", {
                          class: "text-body collapsed d-flex flex-row align-items-center justify-content-between w-100",
                          href: '#collapse-icon-intervention-'+oIndex+sIndex+tIndex,
                          "data-toggle": "collapse"
                        }, [
                          _createElementVNode("div", _hoisted_32, [
                            _createElementVNode("span", null, _toDisplayString(object.company), 1),
                            _createElementVNode("small", null, _toDisplayString(object.street) + " " + _toDisplayString(object.houseNumber) + " | " + _toDisplayString(object.zipCode) + " " + _toDisplayString(object.city), 1),
                            _createElementVNode("span", _hoisted_33, [
                              _createTextVNode(_toDisplayString(system.name) + " | " + _toDisplayString(_ctx.interventionTypesConf[tIndex]['name']) + " ", 1),
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("i", {
                                  class: _normalizeClass(_ctx.interventionTypesConf[tIndex]['icon'])
                                }, null, 2)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("a", {
                              href: "",
                              onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
                              class: "text-body",
                              "data-toggle": "collapse",
                              "aria-expanded": "false"
                            }, _hoisted_37)
                          ])
                        ], 8, _hoisted_31)
                      ]),
                      _createElementVNode("div", {
                        class: "collapse",
                        id: 'collapse-icon-intervention-'+oIndex+sIndex+tIndex
                      }, [
                        _createElementVNode("li", _hoisted_39, [
                          _createElementVNode("div", _hoisted_40, [
                            _createElementVNode("div", _hoisted_41, [
                              _hoisted_42,
                              _createElementVNode("table", _hoisted_43, [
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.old, (intervention, oldIndex) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: oldIndex }, [
                                      _createElementVNode("td", null, [
                                        _createElementVNode("b", _hoisted_44, [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.timeRangeConf[intervention.timeRange]), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_45, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intervention.contactOrder, (unit, oIndex) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: oIndex,
                                              class: "badge badge-pill bg-blue mr-1 mb-1"
                                            }, _toDisplayString(_ctx.interventionTypesConf[tIndex][unit]['name']), 1))
                                          }), 128))
                                        ])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_46, [
                              _hoisted_47,
                              _createElementVNode("table", _hoisted_48, [
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(type.new, (intervention, newIndex) => {
                                    return (_openBlock(), _createElementBlock("tr", { key: newIndex }, [
                                      _createElementVNode("td", null, [
                                        _createElementVNode("b", _hoisted_49, [
                                          _createElementVNode("span", null, _toDisplayString(_ctx.timeRangeConf[intervention.timeRange]), 1)
                                        ]),
                                        _createElementVNode("div", _hoisted_50, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(intervention.contactOrder, (unit, oIndex) => {
                                            return (_openBlock(), _createElementBlock("span", {
                                              key: oIndex,
                                              class: "badge badge-pill bg-blue mr-1 mb-1"
                                            }, _toDisplayString(_ctx.interventionTypesConf[tIndex][unit]['name']), 1))
                                          }), 128))
                                        ])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ])
                        ])
                      ], 8, _hoisted_38)
                    ], 64))
                  }), 128))
                ], 64))
              }), 128))
            ], 64))
          }), 128))
        ])
      ])
    ])
  ]))
}